/*
 * Motion da 86hub Shop: parallax leve.
 *
 * Sem JS, ou com prefers-reduced-motion, nada se move. `html.motion` so e ligada aqui.
 *
 * O reveal ao rolar (itens entrando com opacity 0) saiu em 05/10/2026: no celular, rolando
 * rapido, cards e blocos ficavam em branco ate o IntersectionObserver alcancar, e a cortina
 * do hero atrasava a primeira imagem. Conteudo visivel desde o primeiro quadro vale mais.
 *
 * [data-parallax="fator"] desloca em Y proporcional ao scroll, num requestAnimationFrame,
 * so enquanto o elemento esta perto da viewport.
 */
(function () {
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
  if (window.Shopify && window.Shopify.designMode) return;
  document.documentElement.classList.add("motion");

  function iniciar() {
    var flutuantes = document.querySelectorAll("[data-parallax]");
    if (!flutuantes.length) return;
    var pedido = false;
    function pintar() {
      pedido = false;
      var vh = window.innerHeight;
      for (var i = 0; i < flutuantes.length; i++) {
        var el = flutuantes[i];
        var r = el.getBoundingClientRect();
        if (r.bottom < -200 || r.top > vh + 200) continue;
        var fator = parseFloat(el.getAttribute("data-parallax")) || 0;
        // Distancia do centro do elemento ao centro da tela, em px.
        var d = r.top + r.height / 2 - vh / 2;
        el.style.setProperty("--py", (d * fator).toFixed(1) + "px");
      }
    }
    function agendar() {
      if (pedido) return;
      pedido = true;
      requestAnimationFrame(pintar);
    }
    window.addEventListener("scroll", agendar, { passive: true });
    window.addEventListener("resize", agendar);
    pintar();
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", iniciar);
  else iniciar();
})();
